import { addTruthyParamsToUrl } from '@zapier/url-utils';
import { LOGIN_URL } from '../constants';

// Login URL with `next` back to the current route so the user returns here after
// signing in. Reads window.location, so browser-only.
export function buildLoginUrl() {
  const next =
    window.location.pathname + window.location.search + window.location.hash;
  return addTruthyParamsToUrl(LOGIN_URL, { next });
}
